import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { Dropdown } from 'components/Dropdown/Dropdown';

const monthSelection = [{text: 'Once a month', value: 0}];
const daySelection = [{text: 'On the first day', value: 0}];
const timezoneSelection = [{text: 'Time zone: (GMT-7 Pacific Time/LosAngeles)', value: 'pacific'}];

export class SettingTabMaintenanceScheduleOwner extends Component {
    static propTypes = {
      prop: PropTypes
    }

    constructor(props) {
      super(props);
      this.state = {
        month: monthSelection[0],
        date: daySelection[0],
        timezone: timezoneSelection[0],
        time: null
      };
    }

    render() {
      return (
        <div>
          <span>Maintenance tips not attached to time</span>
        </div>
      );
    }
}

const mapStateToProps = () => ({

});

export default withRouter(connect(mapStateToProps)(SettingTabMaintenanceScheduleOwner));



// WEBPACK FOOTER //
// ./src/Lots/Components/Maintenance/tip-list.js